import { useEffect } from "react";

const FOCUSABLE_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

/**
 * Mobil virtual klaviatura chiqqanda fokusdagi input ko'rinmay (klaviatura ostida)
 * qolib ketishining oldini oladi. Telegram/Click/Payme/Zoomrad webview'larining
 * hech biri buni avtomatik scroll qilmaydi — `visualViewport` o'lchami klaviatura
 * ochilganda kichrayadi, shu hodisani ushlab fokusdagi elementni qayta ko'rinadigan
 * qilamiz (faqat haqiqatan yopilgan bo'lsa, keraksiz sirpanish bo'lmasligi uchun).
 *
 * Bitta marta App ildizida chaqiriladi — barcha input/textarea/select uchun ishlaydi,
 * har bir forma alohida hech narsa qo'shmaydi.
 */
export function useKeyboardScrollFix() {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const scrollFocusedIntoView = () => {
      const el = document.activeElement;
      if (!(el instanceof HTMLElement) || !FOCUSABLE_TAGS.has(el.tagName)) return;

      const rect = el.getBoundingClientRect();
      const visibleHeight = viewport.height;
      const alreadyVisible = rect.top >= 0 && rect.bottom <= visibleHeight;
      if (alreadyVisible) return;

      el.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    viewport.addEventListener("resize", scrollFocusedIntoView);
    return () => viewport.removeEventListener("resize", scrollFocusedIntoView);
  }, []);
}
